// eslint-disable-next-line
const QuickbooksLogo = require('./QuickbooksLogo.png');

export default QuickbooksLogo;
